import React from 'react';
import Tick from '../../images/tick.png';

const defaultPoints = [
  'HOW to spot hidden value in properties that others overlook!',
  'SECRET FORMULA: The numbers that make a property profitable!',
  'EARN double-digit returns without landlording, credit or cash!',
  'HOW to build wealth through real estate step by step!',
];

const defaultHeading = "Here's what you'll take away from these free live events...";

const TakeawayHighlights = ({ heading = defaultHeading, points = defaultPoints }) => (
  <div className="form-side-section">
    <h3>{heading}</h3>
    <div className="form-side-list">
      {points.map((text, index) => (
        <div key={`${text}-${index}`}>
          <img src={Tick} alt="tick" />
          <p>{text}</p>
        </div>
      ))}
    </div>
  </div>
);

export default TakeawayHighlights;
